const serviceImages = {
  privatelabel: require('./services/privatelabel.jpg'),
  oilanalysis: require('./services/oilanalysis.jpg'),
  logistics2: require('./services/logistics2.jpg'),
  fleet: require('./services/fleet.jpg')
}
export default serviceImages
